import { render, staticRenderFns } from "./MyRemoteSupport.vue?vue&type=template&id=2b020f55&scoped=true&"
import script from "./MyRemoteSupport.vue?vue&type=script&lang=js&"
export * from "./MyRemoteSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b020f55",
  null
  
)

export default component.exports